import type { StatusTone } from "@/components/status-badge"

export function deliveryTraceabilityTone(percent: number | null | undefined): {
  tone: StatusTone
  bucket: "accepted" | "atRisk" | "incomplete"
} {
  const p = percent ?? 0
  if (p === 100) return { tone: "success", bucket: "accepted" }
  if (p > 90) return { tone: "warning", bucket: "atRisk" }
  return { tone: "muted", bucket: "incomplete" }
}
